import { ThemeOption } from 'ngx-echarts';
import { FORMATTER_2DAYS_MONTH } from 'src/app/features/reports/components/chart/config/base/default.chart';
import { TOOLTIP_VIEWPORT } from './tooltip-viewport';

export const echart_theme: ThemeOption = {
  version: 1,
  themeName: 'audaces',
  theme: {
    grid: {
      containLabel: true,
      top: 16,
      bottom: 24,
      left: 16,
      right: 16,
      // height: '100%',
      // width: '100%',
      // outerBoundsContain: 'axisLabel',
      // outerBoundsMode: 'auto',
      // outerBounds: {
      //     top: 128,
      //     bottom: 128,
      //     left: 128,
      //     right: 128
      // }
    },
    color: [
      'var(--chart-data-color-0)',
      'var(--chart-data-color-1)',
      'var(--chart-data-color-2)',
      'var(--chart-data-color-3)',
      'var(--chart-data-color-4)',
      'var(--chart-data-color-5)',
      'var(--chart-data-color-6)',
      'var(--chart-data-color-7)',
      'var(--chart-data-color-8)',
    ],
    backgroundColor: 'var(--chart-backgroundColor)',
    textStyle: {
      fontFamily: 'Inter',
    },
    title: {
      textStyle: {
        color: 'var(--chart-textColor)',
        borderColor: 'transparent',
      },
      subtextStyle: {
        color: 'var(--chart-textColor)',
      },
    },
    line: {
      itemStyle: {
        borderWidth: '2',
      },
      lineStyle: {
        width: '3',
      },
      symbolSize: '8',
      symbol: 'circle',
      smooth: false,
      emphasis: {
        focus: 'series',
      },
    },
    radar: {
      itemStyle: {
        borderWidth: '2',
      },
      lineStyle: {
        width: '3',
      },
      symbolSize: '8',
      smooth: false,
    },
    label: {
      hideOverlap: true,
      avoidLabelOverlap: true,
      fontWeight: 500,
      textBorderColor: 'transparent',
      color: 'var(--chart-textColor)',
    },
    axisLabel: {
      hideOverlap: true,
      margin: 10,
    },
    bar: {
      itemStyle: {
        barBorderWidth: '0',
        barBorderColor: '#6dc6c4',
      },
      emphasis: {
        focus: 'series',
        itemStyle: {
          color: 'inherit',
        },
      },
    },
    pie: {
      radius: ['35%', '70%'],
      center: ['35%', '50%'],
      padAngle: 0.1,
      minAngle: 5,

      left: 0,
      selectedMode: 'single',
      avoidLabelOverlap: false,
      label: {
        show: false,
      },
      labelLine: {
        show: false,
      },
      emphasis: {
        focus: 'self',
        itemStyle: {
          color: 'inherit',
        },
      },
    },

    boxplot: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
    },
    parallel: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
    },
    sankey: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
    },
    funnel: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
    },
    gauge: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
    },
    candlestick: {
      itemStyle: {
        color: '#ffee51',
        color0: '#ffffff',
        borderColor: '#ff715e',
        borderColor0: '#797fba',
        borderWidth: '1',
      },
    },
    graph: {
      itemStyle: {
        borderWidth: '0',
        borderColor: '#6dc6c4',
      },
      lineStyle: {
        width: '1',
        color: '#5100ff',
      },
      symbolSize: '8',
      smooth: false,
      color: [
        '#5388d8',
        '#ffaf51',
        '#81a684',
        '#8c6ac4',
        '#4a4bfa',
        '#333333',
        '#333333',
        '#333333',
        '#333333',
      ],
      label: {
        color: 'var(--chart-textColor)',
      },
    },
    map: {
      itemStyle: {
        areaColor: '#555555',
        // "borderColor": "#999999",
        borderColor: 'var(--chart-textColor)',
        borderWidth: 0,
      },
      label: {
        color: 'var(--chart-textColor)',
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgba(255,175,81,0.5)',
          borderColor: '#ffaf51',
          borderWidth: 1,
        },
        label: {
          // "color": "#ffee51"
          color: 'var(--chart-textColor)',
        },
      },
    },
    geo: {
      itemStyle: {
        areaColor: '#555555',
        borderColor: '#999999',
        borderWidth: 0.5,
      },
      label: {
        color: '#ffffff',
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgba(255,175,81,0.5)',
          borderColor: '#ffaf51',
          borderWidth: 1,
        },
        label: {
          color: '#ffee51',
        },
      },
    },
    categoryAxis: {
      axisLine: {
        show: true,
        lineStyle: {
          color: 'var(--chart-axisLineColor)',
        },
      },
      axisTick: {
        show: true,
        alignWithLabel: true,
        lineStyle: {
          color: 'var(--chart-textColor)',
        },
      },
      axisLabel: {
        show: true,
        color: 'var(--chart-textColor)',
        width: 100,
        overflow: 'truncate',
        ellipsis: '...',
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: ['var(--chart-splitLineColor)'],
          type: 'dashed',
        },
      },
      splitArea: {
        show: false,
        areaStyle: {
          color: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
        },
      },
    },
    valueAxis: {
      boundaryGap: [0, 0.35],
      axisLine: {
        show: true,
        lineStyle: {
          color: 'var(--color-fundo-600)',
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: 'var(--chart-textColor)',
        },
      },
      axisLabel: {
        show: true,
        color: 'var(--chart-textColor)',
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['var(--chart-splitLineColor)'],
          type: 'dashed',
        },
      },
      splitArea: {
        show: false,
        areaStyle: {
          color: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
        },
      },
    },
    logAxis: {
      axisLine: {
        show: true,
        lineStyle: {
          color: 'var(--color-fundo-100)',
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: 'var(--chart-textColor)',
        },
      },
      axisLabel: {
        show: true,
        color: 'var(--chart-textColor)',
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['var(--chart-splitLineColor)'],
          type: 'dashed',
        },
      },
      splitArea: {
        show: false,
        areaStyle: {
          color: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
        },
      },
    },
    timeAxis: {
      axisLine: {
        show: true,
        lineStyle: {
          color: 'var(--color-fundo-100)',
        },
      },
      axisTick: {
        show: true,
        lineStyle: {
          color: 'var(--chart-textColor)',
        },
      },
      axisLabel: {
        show: true,
        color: 'var(--chart-textColor)',
        ...FORMATTER_2DAYS_MONTH,
        // margin: 10,
        minInterval: 24 * 3600 * 1000 * 30,

        showMaxLabel: true,
        showMinLabel: true,
      },
      splitLine: {
        show: false,
        lineStyle: {
          color: ['var(--chart-splitLineColor)'],
        },
      },
      splitArea: {
        show: false,
        areaStyle: {
          color: ['rgba(250,250,250,0.05)', 'rgba(200,200,200,0.02)'],
        },
      },
    },
    toolbox: {
      iconStyle: {
        borderColor: 'var(--chart-textColor)',
      },
      emphasis: {
        iconStyle: {
          borderColor: '#eee001',
        },
      },
    },
    legend: {
      show: false,
      type: 'scroll',
      orient: 'horizontal',
      pageIconColor: 'var(--chart-textColor)',
      pageIconInactiveColor: 'var(--chart-textColor)',
      pageTextStyle: { color: 'var(--chart-textColor)' },
      pageIconSize: 12,
      icon: 'circle',
      left: 'center',
      bottom: 0,

      itemGap: 16,
      padding: [8, 0, 0, 0],
      itemHeight: 12,
      textStyle: {
        color: 'var(--chart-textColor)',
        rich: {
          prop: {
            width: 200,
            overflow: 'truncate',
            ellipsis: '...',
            color: 'var(--chart-textColorDark)',
            fontWeight: 400,
            fontSize: 12,
            lineHeight: 16,
            padding: [0, 0, 0, 0],
          },
          valor: {
            fontSize: 12,
            lineHeight: 16,
            fontWeight: 500,
            color: 'var(--chart-textColor)',
            padding: [8, 0, 8, 0],
          },
        },
      },
    },
    tooltip: {
      // Mantém o tooltip dentro da viewport. Como vem do tema, vale para todo
      // chart da app — inclusive os que declaram o próprio `tooltip`. Quem
      // declarar o próprio `extraCssText` deve concatenar TOOLTIP_VIEWPORT_CSS.
      ...TOOLTIP_VIEWPORT,
      axisPointer: {
        lineStyle: {
          color: 'var(--color-fundo-100)',
          width: 1,
        },
        crossStyle: {
          color: 'var(--color-fundo-100)',
          width: 1,
        },
      },
    },
    timeline: {
      lineStyle: {
        color: '#ffaf51',
        width: '0',
      },
      itemStyle: {
        color: '#ffaf51',
        borderWidth: 1,
      },
      controlStyle: {
        color: '#ffaf51',
        borderColor: '#ffaf51',
        borderWidth: 0.5,
      },
      checkpointStyle: {
        color: '#ff715e',
        borderColor: '#ff715e',
      },
      label: {
        color: '#ff715e',
      },
      emphasis: {
        itemStyle: {
          color: '#ffaf51',
        },
        controlStyle: {
          color: '#ffaf51',
          borderColor: '#ffaf51',
          borderWidth: 0.5,
        },
        label: {
          color: '#ff715e',
        },
      },
    },
    visualMap: {
      color: ['#ff715e', '#d88273', '#f6efa6'],
      textStyle: {
        color: 'var(--chart-textColor)',
      },
    },
    dataZoom: {
      // "backgroundColor": "rgba(255,255,255,0)",
      // "dataBackgroundColor": "rgba(222,222,222,1)",
      // "fillerColor": "rgba(255,113,94,0.2)",
      // "handleColor": "var(--color-fundo-100)",
      // "handleSize": "100%",
      // "textStyle": {
      //     "color": "#999999"
      // }
      // borderRadius: 999,
      // borderRadius: [999, 999, 999, 999]
    },
    markPoint: {
      label: {
        color: 'var(--chart-textColor)',
      },
      emphasis: {
        label: {
          color: 'var(--chart-textColor)',
        },
      },
    },
  },
} as const;
